// File: apps/web/src/components/layout/Layout.tsx

import { ReactNode } from 'react';
import { Navbar } from './Navbar';
import { Footer } from './Footer';

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen bg-neutral-900 flex flex-col">
      <Navbar />
      <main className="pt-20 lg:pt-24 flex-1">{children}</main>
      <Footer />
    </div>
  );
}
